import { hc } from "hono/client";
import { AppType } from "api";

export const clientRPC = hc<AppType>(
  import.meta.env.PROD ? "/" : "http://localhost:5173"
);
